/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.controllers {
    export interface IEditFieldScope extends angular.IScope {
        model: models.EditFieldModel;
        close: any;
        dismissModal: any;
    }

    export class EditFieldController extends BaseModalController {
        scope: IEditFieldScope;

        constructor(
            scope: IEditFieldScope,
            field: Wars.Domain.Model.Field,
            close: any,
            service: services.ProcessConfigurationService,
            manageSystemCodesService: services.ManageSystemCodesService,
            systemLevelService: services.SystemLevelService,
            processConfigurationId: string,
            formSection: Wars.Domain.Model.FormSection,
            treeService: services.TreeService,
            manageScheduledResourcesService: services.ManageScheduledResourcesService,
            objectSchemaService: services.ObjectSchemaService,
            manageStaticDocumemtsService: services.ManageStaticDocumentsService,
            autoCompleteConfigurationService: services.AutoCompleteConfigurationService,
            processConfiguration: Wars.Domain.Model.ProcessConfiguration,
            form: Wars.Domain.Model.Form,
            apiGridConfigurationService: services.ApiGridConfigurationService,
            calculationService: services.CalculationService,
            reviewConfigurationService: services.ReviewConfigurationService,
            apiActionService: services.ApiActionService,
            securityMatrixService: services.SecurityMatrixService,
            documentService: services.DocumentService,
            fieldService:services.FieldService,
            growl: angular.growl.IGrowlService,
            processActionService: services.ProcessActionService,
            processTypeService: services.ProcessTypeService,
            mapConfigurationService: services.MapConfigurationService,
            mapOverridesService: services.MapConfigurationOverridesService)
        {
            super(scope, close);
            this.scope = scope;
            this.scope.model = new models.EditFieldModel(
                field,
                service,
                manageSystemCodesService,
                systemLevelService,
                processTypeService,
                processConfigurationId,
                formSection,
                treeService, manageScheduledResourcesService,
                objectSchemaService, manageStaticDocumemtsService, autoCompleteConfigurationService,
                processConfiguration,
                apiGridConfigurationService,
                calculationService,
                reviewConfigurationService,
                apiActionService,
                securityMatrixService,
                documentService,
                form,fieldService,growl,processActionService,mapConfigurationService,mapOverridesService);
        }
    }
}

warsApp.registerController("EditFieldController",
    [ "$scope", "field", "close", "processConfigurationService", "manageSystemCodesService", "systemLevelService", "processConfigurationId",
        "formSection", "treeService", "manageScheduledResourcesService", "objectSchemaService", "manageStaticDocumentsService", "autoCompleteConfigurationService",
        "processConfiguration", "form", "apiGridConfigurationService", "calculationService", "reviewConfigurationService", "apiActionService", "securityMatrixService",
        "documentService", "fieldService", 'growl', 'processActionService', 'processTypeService', 'mapConfigurationService','mapConfigurationOverridesService']);